// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1_Zrt","description":"PatientConsentPreview_description__3fAJK"};